import React, { useEffect, useState } from 'react';
import './expenseManagementStyle.css';
import { useNavigate } from 'react-router-dom';
import { MdOutlineDeleteOutline } from 'react-icons/md';
import { BiEditAlt } from 'react-icons/bi';
import { PiEye } from 'react-icons/pi';


// import LocationFilter from './location_filter/LocationFilter';


// import { delete_location_by_id, get_locations_with_pagination } from '../../../../api/locationApis';
// import { ErrorToast, SuccessToast } from '../../../../toast/toasts';
import CustomDeleteConfirmModal from '../../../components/custom_delete_confirm_modal/CustomDeleteConfirmModal';
import CustomBottomPagination from '../../../components/custom_bottom_pagination/CustomBottomPagination';
import CustomTable from '../../../components/custom_table/CustomTable';
import { LocalStorageServices } from '../../../services/localStorageServices';
import ExpenseManagementFilter from './expense_management_filter/ExpenseManagementFilter';

function ExpenseManagement() {
    const navigate = useNavigate();

    // Base route URL based on user role
    const baseRouteUrl = `/ecrs_portal/${LocalStorageServices.getUserRole()}/ExpenseManagement`;

    // State management
    const [locationListing, setLocationListing] = useState([]);
    const [pageNumber, setPageNumber] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [totalItemsPerPage, setTotalItemsPerPage] = useState(10);
    const [searchFilter, setSearchFilter] = useState(null);
    const [selectedId, setSelectedId] = useState(null);
    const [deleteConfirmation, setDeleteConfirmation] = useState(false);

    // Fetch data whenever page number or items per page changes
    useEffect(() => {
        getLocations(pageNumber, searchFilter);
    }, [pageNumber, totalItemsPerPage]);

    // Fetch location list with pagination and optional filter
    const getLocations = (page, filterValue) => {
        const formData = new FormData();
        formData.append('page', page);
        formData.append('pageItem_count', totalItemsPerPage);

        if (filterValue) {
            Object.entries(filterValue).forEach(([key, value]) => {
                formData.append(key, value);
            });
        }

        // get_locations_with_pagination(formData)
        //   .then((response) => {
        //     setLocationListing(response.data.data);
        //     setTotalPages(response.data.last_page);
        //   })
        //   .catch((error) => {
        //     console.error('Error fetching locations:', error);
        //   });
    };

    // Privilege helpers
    const getPrivilegesDetails = () => JSON.parse(localStorage.getItem('privileges_details') || '[]');

    const hasPrivilege = (privilegeName) =>
        getPrivilegesDetails().some(
            (item) =>
                item.module_name === 'Master Settings' &&
                item.submodules?.['Locations']?.privileges?.some((priv) => priv.name === privilegeName)
        );

    // Uncomment below if privileges are needed
    // const canView = hasPrivilege('View');
    // const canAdd = hasPrivilege('Add');
    // const canEdit = hasPrivilege('Edit');
    // const canDelete = hasPrivilege('Delete');

    // Table columns
    const columns = [
        { title: '#', dataIndex: 'key', key: 'key' },
        { title: 'Expense Head', dataIndex: 'expense_head', key: 'expense_head' },
        { title: 'Amount', dataIndex: 'amount', key: 'amount' },
        { title: 'Remark', dataIndex: 'remark', key: 'remark' },
        {
            title: 'Actions',
            dataIndex: 'actions',
            key: 'actions',
            action: (row) => (
                <div className="locations_action_buttons">
                    {/* View */}
                    <PiEye
                        className="locations_action_view"
                        onClick={() => navigate(`${baseRouteUrl}/${row.id}/view_expense`)}
                    />

                    {/* Edit */}
                    <BiEditAlt
                        className="locations_action_edit"
                        onClick={() => navigate(`${baseRouteUrl}/${row.id}/update_expense`)}
                    />

                    {/* Delete */}
                    <MdOutlineDeleteOutline
                        className="locations_action_delete"
                        onClick={() => {
                            setSelectedId(row.id);
                            setDeleteConfirmation(true);
                        }}
                    />
                </div>
            ),
        },
    ];

    // Delete location
    const deleteLocation = () => {
        if (!selectedId) return;

        // delete_location_by_id(selectedId)
        //   .then((response) => {
        //     if (response.status === 200) {
        //       handleDeleteModalClose(false);
        //       SuccessToast(response.data.message);
        //       getLocations(pageNumber, searchFilter);
        //     }
        //   })
        //   .catch((error) => {
        //     handleDeleteModalClose(false);
        //     ErrorToast(error?.data?.message || 'Failed to delete location');
        //   });
    };

    // Close delete confirmation modal
    const handleDeleteModalClose = (isClose) => {
        setDeleteConfirmation(isClose);
        setSelectedId(null);
    };

    // Prepare data for table
    const tableData = () =>
        locationListing?.map((item, index) => ({
            key: pageNumber * totalItemsPerPage - (totalItemsPerPage - (index + 1)),
            id: item.ld_id,
            name: item.ld_name,
            contact_person_name: item.ld_contact_person_name,
            email: item.ld_email_id,
            phone: item.ld_phone,
            address: item.ld_address,
            status: item.status_name,
        }));

    // Pagination handlers
    const handlePageChange = (page) => setPageNumber(page);
    const handleItemsPerPageChange = (count) => setTotalItemsPerPage(count);

    // Search filter handler
    const handleSearchFilter = (value) => {
        setSearchFilter(value);
        setPageNumber(1);
        getLocations(1, value);
    };
    // Dummy data (replace with API in future)
    const dummyData = [
        { key: 1, id: 1, expense_head: 'Travel', amount: 2500, remark: 'Client meeting in Delhi' },
        { key: 2, id: 2, expense_head: 'Office Supplies', amount: 800, remark: 'Printer ink purchase' },
        { key: 3, id: 3, expense_head: 'Internet Bill', amount: 1200, remark: 'October broadband payment' },
        { key: 4, id: 4, expense_head: 'Food', amount: 600, remark: 'Team lunch' },
        { key: 5, id: 5, expense_head: 'Maintenance', amount: 950, remark: 'AC servicing' },
    ];
    return (
        <div className="expenseManagement_module_main_container">
            <p className="expenseManagement_title">Expense Management</p>

            {/* Filter and Add */}
            <div className="expenseManagement_module_filter">
                <ExpenseManagementFilter searchFilter={handleSearchFilter} />
                <button
                    className="expenseManagement_add_button"
                    onClick={() => navigate(`${baseRouteUrl}/create_new_expense`)}
                >
                    Add New
                </button>
            </div>

            {/* Table */}
            <div className="expenseManagement_table_main_container">
                <CustomTable columns={columns} rows={dummyData} />
            </div>

            {/* Pagination */}
            <CustomBottomPagination
                total_items_per_page={totalItemsPerPage}
                total_page_count={totalPages}
                current_page={pageNumber}
                on_change_value={handlePageChange}
                on_page_count_update={handleItemsPerPageChange}
            />

            {/* Delete Confirmation Modal */}
            <CustomDeleteConfirmModal
                module_name="expense"
                open_modal={deleteConfirmation}
                close_modal={handleDeleteModalClose}
                confirm_function={deleteLocation}
            />
        </div>
    );
}

export default ExpenseManagement;
